export default class guides {
  constructor(manager) {
    this.manager = manager;
    this.guides = [];
  }

  add(guide) {
    this.guides.push(guide);
    guide.subscribe();
    return guide;
  }

  find(key) {
    return this.guides.find(guide => guide.key === key);
  }

  remove(guide) {
    const index = this.guides.indexOf(guide);

    if (index !== -1) {
      this.guides.splice(index, 1);
      guide.unsubscribe();
    }
  }
}
